import React, { ReactNode } from 'react';
import { Dialog } from '@mui/material';
import { GrayClose } from '../../Assets/Icons';
import styles from './dialog.module.scss';
import { DialogCloseIcon } from '../IconComponents';

interface IProps {
  open: boolean;
  children: ReactNode;
  onClose: () => void;
  ref?: React.MutableRefObject<HTMLDivElement | null>;
}

const CustomDialog: React.FC<IProps> = (props) => {
  const { open, children, onClose, ref } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false} 
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(5px)',
          },
        },
      }}
      disableScrollLock={true}
      PaperProps={{
        style: {
          overflow: 'visible',
          position: 'relative',
          padding: 0,
          maxWidth: 'unset',
          borderRadius:'15px'
        },
      }}
    >
      <div className={styles.closeBox} onClick={onClose}>
        <div className={styles.closeIcon}>
          <DialogCloseIcon color='var(--icon-color)'/>
        </div>
        {/* <img
          src={GrayClose}
          alt='closeIcon.svg'
          className={styles.closeIcon}
        /> */}
      </div>
      <div ref={ref} className={styles.dialogContainer}>
        {children}
      </div>
    </Dialog>
  );
};

export default CustomDialog;
